import fetchServer from "../../fetchServer";
import { PDF_API_BASE } from "./pdfApiBase";

/**
 * GET /api/v1/credentials — list Adobe PDF credentials (admin).
 */
export default async function getPdfCredentials() {
  let result = {
    return: 0,
    msg: "Something went wrong fetching PDF credentials",
    data: [],
  };

  try {
    const res = await fetchServer({
      method: "GET",
      url: "/api/v1/credentials",
      api: PDF_API_BASE,
    });

    if (res?.data && !res?.data?.error) {
      const payload = res.data?.data;
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(res.data)
            ? res.data
            : [];
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: items,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.error) {
      result.msg = res.error;
    } else if (res?.data?.message) {
      result.msg = res.data.message;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
